import {createNamespacedHelpers} from "vuex";

export default class {
	constructor(store) {
		this.maps = createNamespacedHelpers(store);
	}

	computed(extra) {
		let defaults = [
			"columns",
			"items",
			"links",
			"loaded",
			"gettingModels",
			"downloading",
			"meta",
			"query",
			"filters",
			"stats",
		];

		return this.maps.mapState(defaults);
	}

	actions(extra) {
		let defaults = [
			"getModels",
			"download",
			"updateModel",
			"replaceModel",
			"goToPage",
			"paginate",
			"filter",
		];

		return this.maps.mapActions(defaults);
	}

	mutations(extra = []) {
		return this.maps.mapMutations(extra);
	}

	getters(extra = []) {
		return this.maps.mapGetters(extra);
	}
}
